export default "__VITE_ASSET__D9LQ0Ncl__";